<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';
  $height: 75px;
  $background: hsl(0, 0, 85);
  .topbar {
    height: $height;
  }
  .logo {
    height: $height;
    padding: 14px;
  }
  .dropdown {
    margin-right: 10px;
  }
  .icon {
    padding-left: 10px;
    color: $primary;
  }
  .toggle {
    padding: 15px;
    &:hover {
      background: $background;
    }
  }
  .drop {
    background: $background;
    box-shadow: 3px 3px 3px 1px rgba(0,0,0,0.10);
    a {
      padding:  15px;
    }
    a:hover {
      background: hsl(0, 0, 83);
    }
  }
  /deep/ .showing {
    background: $background;
  }
  a {
    color: hsl(0, 0, 30);
  }
  .banner {
    color: $primary;
    font-size: 35px;
    font-weight: bolder;
    text-transform: uppercase;
  }
</style>


<template>
  <div class="topbar flex-h flex-limit flex-items-center">

    <!-- logo -->
    <router-link to="dashboard"><img class="image logo" src="@/assets/images/fend-logo.png"></router-link>
    <div class="flex-spacer flex-c banner">
      {{title}}
    </div>

    <!-- menu -->
    <c-dropdown class="dropdown flex-h flex-limit">

      <!-- toggle -->
      <template #toggle>
        <div class="toggle flex-h">
          <div>{{user.email}}</div>
          <c-icon class="icon" icon="fas-chevron-down"/>
        </div>
      </template>

      <!-- dropdown -->
      <template #menu>
        <div class="drop flex-v">
          <router-link to="/profile">Edit profile</router-link>
          <a href="#" @click.prevent="logout">Sign out</a>
        </div>
      </template>
    </c-dropdown>
  </div>
</template>


<script>
import api from '@/api';
import { get } from 'vuex-pathify';


export default {
  name: 'topbar',
  computed: {
    user: get('user'),
    title() {
      return process.env.VUE_APP_BANNER || '';
    }
  },
  methods: {
    async logout() {
      await api.auth.logout();
      this.$router.push('/login');
    }
  }
};
</script>
